import { EMPTY_STRING } from 'common/constants';
import { REFRESH_TOKEN } from './constants';

export const getResfreshToken = (): string =>
  (window.localStorage.getItem(REFRESH_TOKEN) as string) || EMPTY_STRING;

export const setRefreshToken = (value: string): void => {
  window.localStorage.setItem(REFRESH_TOKEN, value);
};

export const deleteRefreshToken = () => {
  window.localStorage.removeItem(REFRESH_TOKEN);
};
